module.exports = {
    path: '/playerLog',
    name: 'playerLog',
    meta: { title: '球员数据管理', icon: 'el-icon-user', hidden: true },
    component: () => import('../views/playerLog/playerLog.vue')
}